import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { environment } from '@environments/environment';
import { catchError, of } from 'rxjs';
import { ICompetitionSummary } from '../models';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class CompetitionDetailsService {
  private http = inject(HttpClient);
  private router = inject(Router);

  private env = environment;
  private headers = new HttpHeaders({
    'Content-Type': 'application/json',
  });

  isLoadingCompetitionDetails = signal<boolean>(false);
  isErrorCompetitionDetails = signal<boolean>(false);
  competitionDetails = signal<ICompetitionSummary | null>(null);

  getCompetitionDetails(
    competitionId: String,
    callback?: () => void,
    isRefreshing: boolean = false
  ) {
    if (!isRefreshing) this.isLoadingCompetitionDetails.set(true);
    this.isErrorCompetitionDetails.set(false);

    this.http
      .get<ICompetitionSummary | null>(
        `${this.env.baseUrlWeb}/competitions/${competitionId}/summary`,
        {
          headers: this.headers,
        }
      )
      // of(this.mockData)
      .pipe(
        catchError((err) => {
          this.isLoadingCompetitionDetails.set(false);
          this.isErrorCompetitionDetails.set(true);

          if (err.error.Code === 'COMPETITION_ERROR_012') {
            this.router.navigate(['/404']);
          }

          return of(null);
        })
      )
      .subscribe((data) => {
        if (!data) {
          this.competitionDetails.set(null);
          return;
        }

        this.competitionDetails.set(data);
        callback && callback();
        this.isLoadingCompetitionDetails.set(false);
      });
  }
}
